import { styled } from '@stitches/react';
import { ReactComponent as ReactangleShape } from '@assets/icons/rectangle-shape.svg';

export const StyledRectangleShape = styled(ReactangleShape, {});
